import { useState, useEffect } from 'react';

export const useResponsiveLayout = (): {
  isTablet: boolean;
  isDesktop: boolean;
  isPortrait: boolean;
} => {
  const [isTablet, setIsTablet] = useState<boolean>(false);
  const [isDesktop, setIsDesktop] = useState<boolean>(false);
  const [isPortrait, setIsPortrait] = useState<boolean>(false);

  useEffect(() => {
    const handleResize = () => {
      setIsTablet(window.innerWidth < 1310 || window.innerHeight < 700);
      setIsDesktop(window.innerWidth >= 1310 && window.innerHeight >= 700);
      setIsPortrait(window.innerHeight > window.innerWidth);
    };

    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { isTablet, isDesktop, isPortrait };
};
